import mandalAsset from "@/assets/doctors/dr-narendra-kishor-mandal.jpeg.asset.json";
import { PILES_TREATMENT_CITIES, type PilesTreatmentCity } from "@/components/PilesTreatmentCityPage";
import { HERNIA_GURGAON_HTML, herniaGurgaonFaqs } from "@/lib/hernia-gurgaon-lp";

export type HerniaCostCity = PilesTreatmentCity;

export function herniaCostCity(slug: string): HerniaCostCity | undefined {
  return (Object.keys(PILES_TREATMENT_CITIES) as HerniaCostCity[]).find(
    (city) => PILES_TREATMENT_CITIES[city].slug === slug,
  );
}

export function herniaCostFaqs(city: HerniaCostCity) {
  return herniaGurgaonFaqs.map(({ q, a }) => ({
    q: q.replaceAll("Gurgaon", city),
    a: a.replaceAll("Gurgaon", city),
  }));
}

/** Preserve the approved body layout, changing only local doctor and hospital details. */
export function herniaCostHtml(city: HerniaCostCity): string {
  if (city === "Gurgaon") return HERNIA_GURGAON_HTML;
  const config = PILES_TREATMENT_CITIES[city];
  return HERNIA_GURGAON_HTML
    .replaceAll(mandalAsset.url, config.doctorImage)
    .replaceAll("Dr. N.K. Mandal", config.doctor)
    .replaceAll("MBBS · MS (Surgery) · DNB (Urology)", config.doctorShortQuals)
    .replaceAll("MBBS, MS (General Surgery), DNB (Urology)", config.doctorEducation)
    .replaceAll("30+ years · General &amp; laparoscopic surgery", config.doctorRole)
    .replaceAll("30+ years of surgical experience", config.doctorFellowships)
    .replace(/<div class="loc-address">[\s\S]*?<\/div>/, `<div class="loc-address">${config.address}</div>`)
    .replace(/<div class="loc-landmark">[\s\S]*?<\/div>/, `<div class="loc-landmark">Near: ${config.addressShort}</div>`)
    .replaceAll("https://maps.google.com/maps?q=Healic+Multispecialty+Hospital+Sohna+Road+Gurgaon&amp;z=14&amp;output=embed", config.mapUrl.replaceAll("&", "&amp;"))
    .replaceAll("Gurgaon", city)
    .replaceAll("Gurugram", city);
}